import React from "react";

export default function Team() {
    return(
        <>
        {/* BREADCRUMB AREA START */}
        <div
          className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
          data-bs-bg="img/bg/sunrise-medical.jpg"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="ltn__breadcrumb-inner">
                  <h1 className="page-title">Our Team</h1>
                  <div className="ltn__breadcrumb-list">
                    <ul>
                      <li>
                        <a href="index.html">
                          <span className="ltn__secondary-color">
                            <i className="fas fa-home" />
                          </span>{" "}
                          Home
                        </a>
                      </li>
                      <li>Team</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* BREADCRUMB AREA END */}
        {/* TEAM AREA START (Team - 3) */}
        <div className="ltn__team-area pt-110--- pb-90">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/4.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">Rosalina D. William</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Scientist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/2.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">Kelian Anderson</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Dentist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/3.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">Miranda H. Halim</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Caardiologist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/1.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">Damble D. Browni.</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Assistant</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/5.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">Aiden Benjamin</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Scientist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/6.jpg" alt="Image" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <a href="team-details.html">James Carter</a>
                    </h4>
                    <h6 className="ltn__secondary-color">Dentist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* TEAM AREA END */}
      </>
      
    );

}